import { Discount } from '../../types/discounts';
import { DropdownOption } from './components/MarketingDropdown';
import { parseDiscount } from '../utils/parseDiscountFromBackend';

interface Helpers {
    days: DropdownOption[];
    months: DropdownOption[];
    itemsBought: DropdownOption[];
}

export const parseDiscountToFrontendType = (discount: Discount, helpers: Helpers) => {
    const parsedDiscount = parseDiscount(discount, helpers);

    const fromDate = new Date(discount.requirement.purchase_from ?? 0).getTime();
    const toDate = new Date(discount.requirement.purchase_to ?? 0).getTime();

    return {
        ...parsedDiscount,
        dateFrom: new Date(fromDate),
        dateTo: new Date(toDate),
        timeFrom: new Date(fromDate),
        timeTo: new Date(toDate),
    };
};
